import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonModal
} from "@ionic/react";
import { useParams } from "react-router";
import { useBotsStore } from "../stores/bots.store";
import TradeListItem from "../components/TradeListItem";
import SellConfig from "../components/SellConfig";
import GenericInfo from "../pages/GenericInfo";
import { addBotAction, createActionByType } from "../lib/firebase";
import { useAuthStore } from "../stores/auth.store";
import { cashOutline } from "ionicons/icons";
import { useHistory } from "react-router-dom";

const TradeInfo: React.FC = () => {
  const botId: string = useParams<{ botId: string }>().botId;
  const tradeId = useParams<{ tradeId: string }>().tradeId;
  const history = useHistory();
  const uid = useAuthStore(state => state.user?.uid);
  const bot: any = useBotsStore(state =>
    state.bots.find(bot => bot.id === botId)
  );
  const trade = bot?.data?.trades[tradeId];

  const [presentConfirm, dismissConfirm] = useIonModal(GenericInfo, {
    onDismiss: (confirm: boolean) => {
      dismissConfirm();
      if (confirm && uid && botId) {
        const action = createActionByType("closeTrade", uid, {
          botId,
          payload: { tradeId: trade?.id },
          coinPair: trade?.coinPair
        });
        addBotAction(botId, action)
          .then(() => console.log("Manual sell signal sent."))
          .catch((error: any) =>
            console.error("Data could not be saved." + error)
          );
        history.goBack();
      }
    },
    title: `Sell ${trade?.coinPair?.replace("USDT", "")}`,
    subtitle: `Are you sure you want to manually sell ${trade?.coinPair?.replace(
      "USDT",
      ""
    )}?`,
    buttonText: "Yes - Sell",
    icon: cashOutline
  });

  if (!bot || !trade) {
    return null;
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle>Trade Info</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <TradeListItem trade={trade} botId={botId} navigate={false} />
        <div className="mx-auto p-3">
          <IonButton
            expand="block"
            onClick={() => presentConfirm()}
            className="bg-primary-90"
          >
            Manual Sell
          </IonButton>
        </div>
        <SellConfig trade={trade} bot={bot} />
      </IonContent>
    </IonPage>
  );
};

export default TradeInfo;
